import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import { Grid, Typography } from '@material-ui/core';
import { Row } from '../../Resources';
import ActivitiesRegistrationHeader from 'components/ActivitiesRegistrationDetails/ActivitiesRegistrationHeader';

import { convertToReal } from 'helpers/converters';

export default function InvoiceRestoration({ activityData, newRegister }) {
  return(
    <Grid container>
      <Grid xs={12}>
        <ActivitiesRegistrationHeader
          activityData={activityData}
        />
      </Grid>
      <Grid xs={12} style={{ border: '1px solid #D7D7D7', borderRadius: 5, backgroundColor: '#FCFCFC', padding: 8, marginTop: 10 }}>
        <Row>
          <Typography color='primary'>
            <b>Funcionário</b>
          </Typography>
          <Typography color='textSecondary'>{newRegister?.clientName || '--'}</Typography>
        </Row>
        <Row>
          <Typography color='primary'>
            <b>Data de vencimento</b>
          </Typography>
          <Typography color='textSecondary'>{moment(newRegister?.invoiceDueDateTime).format('DD/MM/YYYY')}</Typography>
        </Row>
        <Row>
          <Typography color='primary'>
            <b>Valor</b>
          </Typography>
          <Typography color='textSecondary'>{convertToReal(newRegister?.amount)}</Typography>
        </Row>
      </Grid>
    </Grid>
  );
}

InvoiceRestoration.propTypes = {
  activityData: PropTypes.object.isRequired,
  newRegister: PropTypes.object.isRequired
};